import { useLocalization } from "@/data/Localization";
import { Stack, Checkbox, Typography } from "@mui/material";
import { ChangeEvent, FC, useContext, useMemo } from "react";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { LatLng } from "@/data/types/Store";
import { ContentContext } from "@/data/context/content";
import { useClickAndCollect } from "@/data/Content/ClickAndCollect";

type Props = {
    setLatLng: (value: LatLng) => void
}

export const StoreListActions: FC<Props> = ({setLatLng}) => {
    
    const clickAndCollectNLS = useLocalization("ClickAndCollect");
    const {
        handleShowNearStoresCheckChange,
        stores,
        showSearchByLocation,
        setShowSearchByLocation,
        showSearchNearStores,
    } = useContext(ContentContext) as ReturnType<typeof useClickAndCollect>;
    useMemo(()=>{
        const showNearStoreChkbox = document?.getElementById('cc-select-nearby-stores-pdp') as HTMLInputElement;
        if(showNearStoreChkbox?.checked)showNearStoreChkbox.click();
    },[stores])
    const handleSeachByocationChange = (event:ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setShowSearchByLocation(checked);
        if(checked){
            navigator.geolocation.getCurrentPosition(
                async (position: GeolocationPosition) => {
                    setLatLng({ lat: position.coords.latitude, lng: position.coords.longitude });
                    //clearSearchTermAndCloseEverything();
                },
                (err: any) => {
                    //logError(undefined, 'StoreLocator: findNearStore: error: %o', err);
                }
            );
        }
        
    }
    return (
        <Stack rowGap={1}>
            <Stack pl={0.5} direction="row" alignItems="center" columnGap={1}>
                <Checkbox
                    checked={showSearchByLocation}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => handleSeachByocationChange(event)}
                    checkedIcon={<CheckBoxIcon />}
                    sx={{ p: 0 }}
                    id="cc-search-with-current-location-pdp"
                />
                <Typography component={"label"} htmlFor="cc-search-with-current-location-pdp" sx={{ cursor: 'pointer' }}>
                    {clickAndCollectNLS.SearchByLocation.t()}
                </Typography>
            </Stack>
            {stores?.length > 0 ?
                <Stack pl={0.5} direction="row" alignItems="center" columnGap={1}>
                    <Checkbox
                        onChange={(event: ChangeEvent<HTMLInputElement>) => handleShowNearStoresCheckChange(event)}
                        checkedIcon={<CheckBoxIcon />}
                        checked={showSearchNearStores}
                        sx={{ p: 0 }}
                        id="cc-select-nearby-stores-pdp"
                    />
                    <Typography component={"label"} htmlFor="cc-select-nearby-stores-pdp" sx={{ cursor: 'pointer' }}>
                        {clickAndCollectNLS.ShowNearestStoresWithStock.t()}
                    </Typography>
                </Stack>:null
            }
        </Stack>
    );
}